module.exports = __webpack_public_path__ + "static/media/ArchiveIconTableRow.00426692.svg";